export const mergeIndexed = (a, b) => {
  if ([a, b].some((v, i) => !Array.isArray(v))) {
    throw Error('All arguments should be Arrays.');
  }
  return a.reduce((acc, cur, i) => [...acc, cur, b[i]], []);
};
